/**
 * @desc 根据审批号查询SPU主体信息（用于新增时...）
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.ProductMasterResponseDto>;
export function request(puno: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productMaster/masterDetail/${puno}`, {
      method: "GET",

      ...options,
    }),
  );
}
